import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {withRouter} from 'react-router-dom';
import {TIERS} from '../constants';
import {hasPermission, setPermissions} from '../forecast-app/shared/util/PermissionsUtil';

import NpsV2 from '../components/nps/NpsV2';
import {ForecastThemeProvider} from 'web-components';
import {EVENT_ID, subscribe} from './event_manager';
import {PERMISSION_TYPE} from '../Permissions';
import moment from 'moment';
import Util from '../forecast-app/shared/util/util';
import {setAvailableFeatureFlags} from "../forecast-app/shared/util/FeatureUtil";
import {setEnabledModules} from "../forecast-app/shared/util/ModuleUtil";

class appv2 extends Component {
	constructor(props) {
		super(props);

		Util.localStorageSetItem('CSRF-TOKEN', props.viewer.csrfToken);
		setPermissions(props.viewer.permissions);
		setAvailableFeatureFlags(props.viewer.availableFeatureFlags);
		setEnabledModules(props.viewer.company.modules);
	}

	UNSAFE_componentWillMount() {
		if (this.props.viewer.downForMaintenance) {
			this.props.history.push({
				pathname: '/maintenance',
			});
			return;
		}

		const isTrial = this.props.viewer.company.tier === TIERS.TRIAL;
		const isOnTrialEnd = this.props.history.location.pathname === '/trial-end';
		const trialEndTime = moment.utc(this.props.viewer.company.trialEndTime);
		const now = moment.utc();
		if (isTrial && !isOnTrialEnd && trialEndTime.isBefore(now)) {
			this.props.history.push('/trial-end');
		}

		this.props.setLocale && this.props.setLocale(this.props.viewer.language);
	}

	componentDidMount() {
		if (this.props.viewer.actualPersonId === null) {
			this.props.history.push({
				pathname: '/login',
			});
		} else if (this.props.viewer && this.props.viewer.company && this.props.viewer.company.accessBlocked && !['/trial-end', '/access-blocked', '/settings/subscription'].includes(this.props.history.location.pathname)) {
			this.props.history.push('/access-blocked');
		}

		// Page shown time monitoring
		this.loadtimeMonitoring = performance.now();
		this.props.history.listen(() => {
			this.loadtimeMonitoring = performance.now();
		});

		// Subscribe to log time since start loading
		subscribe(EVENT_ID.PAGE_LOADED, path => {
			const loadTime = Math.round(performance.now() - this.loadtimeMonitoring);
			const init = {credentials: 'include'};
			fetch(process.env.GRAPHQL_ENDPOINT.slice(0, -7) + 'page_show_tracking?url=' + path + '&time=' + loadTime, init);
		});
	}

	componentDidUpdate(prevProps) {
		// Check necessary to prevent infinite update
		if (this.props.viewer.actualPersonId === null && (!this.props.location.state || this.props.location.state.nextPathname !== '/login')) {
			this.props.history.push({
				pathname: '/login',
				state: {nextPathname: this.props.location.pathname},
			});
		}
		// Catch impersonation changes
		if (prevProps.viewer.actualPersonId !== this.props.viewer.actualPersonId || prevProps.viewer.permissions !== this.props.viewer.permissions) {
			setPermissions(this.props.viewer.permissions);
			setAvailableFeatureFlags(this.props.viewer.availableFeatureFlags);
			setEnabledModules(this.props.viewer.company.modules);
		}
	}

	render() {
		if (this.props.viewer.actualPersonId === null) {
			return <div />;
		}

		const isAdmin = hasPermission(PERMISSION_TYPE.MANAGE_ACCOUNT_SETTINGS);
		const isTrial = this.props.viewer.company.tier === TIERS.TRIAL;
		const isOnTrialEnd = this.props.history.location.pathname === '/trial-end';
		const trialEndTime = this.props.viewer.company.trialEndTime;

		const buyNowTime = isAdmin && isTrial && !isOnTrialEnd && trialEndTime;

		return (
			<>
				{this.props.appContent(this.props.viewer.actualPersonId, this.props.viewer.availableFeatureFlags, this.props.viewer.company.modules, buyNowTime)}
				<ForecastThemeProvider>
					<NpsV2 npsShouldShow={this.props.viewer.npsShouldShow} cesOverviewShouldShow={this.props.viewer.cesOverviewShouldShow} personId={this.props.viewer.actualPersonId} />
				</ForecastThemeProvider>
			</>
		);
	}
}

const appv2Query = graphql`
	query appv2_Query {
		viewer {
			actualPersonId
			component(name: "appv2")
			...appv2_viewer
		}
	}
`;

export {appv2Query};

export default createFragmentContainer(withRouter(appv2), {
	viewer: graphql`
		fragment appv2_viewer on Viewer {
			id
			csrfToken
			actualPersonId
			permissions
			downForMaintenance
			availableFeatureFlags {
				key
			}
			email
			language
			npsShouldShow
			cesOverviewShouldShow
			company {
				id
				accessBlocked
				trialEndTime
				tier
				modules {
					moduleType
				}
			}
		}
	`,
});
